import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export default function LoadingState({ message = 'Loading...' }) {
  return (
    <div className="flex flex-col items-center justify-center p-12 text-gray-400">
      <SafeIcon icon={FiIcons.FiLoader} className="text-4xl animate-spin mb-4 text-blue-500" />
      <p className="text-lg font-medium">{message}</p>
    </div>
  );
}